const NANP_DISPLAY_PATTERN = /^\+\d{1,3} \(\d{3}\) \d{3}-\d{4}$/;

/**
 * Format stored phones (E.164 or legacy) for read-only UI: +1 (AAA) BBB-CCCC.
 * Does not mutate API values — display only.
 */
export function formatPhoneForDisplay(
  raw: string | null | undefined,
): string {
  if (raw == null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';

  if (NANP_DISPLAY_PATTERN.test(trimmed)) {
    return trimmed;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return trimmed;

  let countryCallingCode: string;
  let nationalNumber: string;

  const hadPlusPrefix = trimmed.startsWith('+');

  if (hadPlusPrefix) {
    if (digits.startsWith('1') && digits.length === 11) {
      countryCallingCode = '1';
      nationalNumber = digits.slice(1);
    } else {
      return trimmed;
    }
  } else if (digits.length === 10) {
    countryCallingCode = '1';
    nationalNumber = digits;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    countryCallingCode = '1';
    nationalNumber = digits.slice(1);
  } else {
    return trimmed;
  }

  if (nationalNumber.length !== 10) {
    return trimmed;
  }

  const area = nationalNumber.slice(0, 3);
  const prefix = nationalNumber.slice(3, 6);
  const line = nationalNumber.slice(6, 10);
  return `+${countryCallingCode} (${area}) ${prefix}-${line}`;
}
